/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Ad_Volume_LabelInputs */



/**
* | output |
* | --- |
* | "Audio description volume" |
*
* @param {Player_Ad_Volume_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_ad_volume_label = /** @type {((inputs?: Player_Ad_Volume_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Ad_Volume_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Volume de l'audiodescription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautstärke der Audiodeskription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Volume dell'audiodescrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Громкость тифлокомментария")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volumen de la audiodescripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("口述影像音量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声解説の音量")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण वॉल्यूम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Volume da audiodescrição")
	return /** @type {LocalizedString} */ ("Audio description volume")
});